import GetCompetitiveEdgeRequest from "../Requests/GetCompetitiveEdgeRequest";
import BaseServiceApi from "BaseServiceApi";
import AITextFeedbackRequest from "../Requests/AITextFeedbackRequest";
import GetZigzagTrendDataRequest from "../Requests/GetZigzagTrendDataRequest";
import GetFinancialBlockMetricsDataRequest from "../Requests/GetFinancialBlockMetricsDataRequest";
import GetAiFutureEventsRequest from "../Requests/GetAiFutureEventsRequest";
import GetAiStatisticsRequest from "../Requests/GetAiStatisticsRequest";

class AINewsApi {
  getCompetitiveEdgeRequest(data, osid, companyName) {
    const req = new GetCompetitiveEdgeRequest(data, osid, companyName);
    return BaseServiceApi.processAIServiceCall(req);
  }

  aiTextFeedbackRequest(data) {
    const req = new AITextFeedbackRequest(data);
    return BaseServiceApi.processAIServiceCall(req);
  }
  getZigzagTrendDataRequest(
    symbol,
    startDate,
    endDate,
    trendType,
    osid,
    companyName
  ) {
    const req = new GetZigzagTrendDataRequest(
      symbol,
      startDate,
      endDate,
      trendType,
      osid,
      companyName
    );
    return BaseServiceApi.processAIServiceCall(req);
  }
  getFinancialBlockMetricsDataRequest(payload) {
    const req = new GetFinancialBlockMetricsDataRequest(payload);
    return BaseServiceApi.processAIServiceCall(req);
  }
  getAiFutureEvents(payload) {
    const req = new GetAiFutureEventsRequest(payload);
    return BaseServiceApi.processAIServiceCall(req);
  }
  getAiStatisticsRequest(payload) {
    const req = new GetAiStatisticsRequest(payload);
    return BaseServiceApi.processServiceCall(req);
  }
}

var aiNewsApi = new AINewsApi();
export default aiNewsApi;
